var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaestro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.66,
    y: 0.5,
    width: 25.369,
    height: 17.613,
    rx: 3.5,
    fill: "#fff",
    stroke: "#E3EAE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.094 9.079c0 2.872-2.301 5.2-5.14 5.2-2.84 0-5.142-2.328-5.142-5.2 0-2.873 2.302-5.201 5.141-5.201 2.84 0 5.141 2.328 5.141 5.2z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.762 9.079c0 2.872-2.301 5.2-5.14 5.2-2.84 0-5.142-2.328-5.142-5.2 0-2.873 2.302-5.201 5.141-5.201 2.84 0 5.141 2.328 5.141 5.2z",
    fill: "#2F80ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.287 13.037a5.214 5.214 0 001.807-3.959 5.214 5.214 0 00-1.807-3.958 5.214 5.214 0 00-1.807 3.958c0 1.586.702 3.006 1.807 3.96z",
    fill: "#6C6BBD"
  })));
}
export default __webpack_public_path__ + "static/media/Maestro.aa0500b2.svg";
export { SvgMaestro as ReactComponent };